import { getBalance } from '@wagmi/core'
import { CurrencyMetadata } from 'indices-list'
import { atom } from 'jotai'
import { Address, isAddressEqual, zeroAddress } from 'viem'
import { QUERY_KEY_USER_BALANCE } from '../keys'
import { emptyBalance, PriceRequestAtoms } from './model'
import { DEFAULT_REFETCH_INTERVAL } from '../refetch-intervals'
import { formatWeiToAmount } from 'utils'
import { defaultCurrency } from '../zero-ex-requests/quotes/model'
import { networkToChain, wagmiConfig } from 'services/wallet/chains'
import { createAtomsWithQuery } from '../atomic-factory'

const userNativeBalanceQuery = async <T>({
  queryKey: [, userAddress, nativeCurrency],
}: {
  queryKey: [string, Address, CurrencyMetadata]
}) => {
  if (isAddressEqual(userAddress, zeroAddress)) {
    return emptyBalance as T
  } else {
    const response = await getBalance(wagmiConfig, {
      address: userAddress,
      chainId: networkToChain(nativeCurrency.chainId).id,
    })
    return formatWeiToAmount(response.value, response.decimals) as T
  }
}

export const nativeBalanceQueryAtomsFactory = () => {
  const userAddressAtom = atom<Address>(zeroAddress)
  const currentAsset = atom<CurrencyMetadata>(defaultCurrency)

  const mainProperties = createAtomsWithQuery<
    Big,
    Address,
    CurrencyMetadata,
    null,
    [string, Address, CurrencyMetadata]
  >(
    { first: userAddressAtom, second: currentAsset },
    QUERY_KEY_USER_BALANCE,
    userNativeBalanceQuery<Big>,
    DEFAULT_REFETCH_INTERVAL,
    'userNativeBalanceQuery',
  )

  return {
    userAddress: userAddressAtom,
    currentAsset: currentAsset,
    ...mainProperties,
  } as PriceRequestAtoms
}
